import { render, staticRenderFns } from "./RptEventRevenue.vue?vue&type=template&id=0810dbf9&scoped=true&"
import script from "./RptEventRevenue.vue?vue&type=script&lang=js&"
export * from "./RptEventRevenue.vue?vue&type=script&lang=js&"
import style0 from "./RptEventRevenue.vue?vue&type=style&index=0&id=0810dbf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810dbf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
